var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a_2_upperContent"},[_c('VidUtil',{attrs:{"src":_vm.vids[_vm.current],"loop":_vm.loop[_vm.current],"width":"3840","height":"700","duration":"1","endCallBack":_vm.vidEnded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }